import Api from './api'

export default {
  baseUrl: 'Config',

  /**
   * getUiConfig
   *
   * @returns {Promise}
   */
  getUiConfig () {
    // Asked every 10 seconds: an unreachable server is reported by the pages that need it
    return Api.publicFetch(`${this.baseUrl}/Ui`, { silent: true })
  },

  /**
   * getMaintenanceWindows
   *
   * @returns {Promise}
   */
  getMaintenanceWindows () {
    return Api.baseFetch(`${this.baseUrl}/MaintenanceWindow`)
  },
}
